import React from "react";
import { ExpenseByVendorResponse } from "@common/types/reports/types";
import { ReportPresentationChrome } from "@common/schemas/domains/reportSettings/report-presentation.schema";
import { NumberFormatValues } from "@common/schemas/domains/reportSettings/number-format-setting.schema";
import { ExpenseByVendorSort } from "@common/helpers/expenseByVendorSort";
import { Card } from "@design-system/Card/Card";
import { CardSection } from "@design-system/Card/CardSection";
import { AccountingReportHeader } from "../AccountingReportHeader";
import { AccountingReportFooter } from "../AccountingReportFooter";
import {
    AccountingReportContext,
    useAccountingReportContextValue,
} from "../AccountingReport.context";
import { useReportChrome } from "../useReportChrome";
import { GlTableCallbacks } from "../glDrillDown.lib";
import { AccountingReportFilters } from "../types";
import { ExpenseByVendorTable } from "./ExpenseByVendorTable";

interface Props {
    data: ExpenseByVendorResponse;
    filters: AccountingReportFilters;
    chrome: ReportPresentationChrome;
    numberFormat: NumberFormatValues;
    generationDate: Date;
    sort: ExpenseByVendorSort;
    onSortChange: (sort: ExpenseByVendorSort) => void;
    onDrillDown: GlTableCallbacks["onDrillDown"];
}

export const ExpenseByVendorContent: React.FC<Props> = ({
    data,
    filters,
    chrome,
    numberFormat,
    generationDate,
    sort,
    onSortChange,
    onDrillDown,
}) => {
    const resolvedChrome = useReportChrome({
        chrome,
        generationDate,
    });
    const accountingReportContextValue = useAccountingReportContextValue(
        filters,
        numberFormat,
    );

    return (
        <Card stacked sharpEdges fullPage>
            <AccountingReportContext.Provider
                value={accountingReportContextValue}
            >
                <CardSection>
                    <AccountingReportHeader chrome={resolvedChrome} />
                </CardSection>
                <ExpenseByVendorTable
                    data={data}
                    sort={sort}
                    onSortChange={onSortChange}
                    onDrillDown={onDrillDown}
                />
                <AccountingReportFooter chrome={resolvedChrome} />
            </AccountingReportContext.Provider>
        </Card>
    );
};
